var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.984,
    y2: 0.483,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84f9b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed5ef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-app_icon_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app_icon_4",
    "data-name": "app_icon \\u2013 4",
    clipPath: "url(#clip-app_icon_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14",
    "data-name": "\\uADF8\\uB8F9 14",
    transform: "translate(2 -4.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uAC00\\uC6B4\\uB370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_103",
    "data-name": "\\uD328\\uC2A4 103",
    d: "M4455.279,984.85h61.989",
    transform: "translate(-3977 -594)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_104",
    "data-name": "\\uD328\\uC2A4 104",
    d: "M4438.859,1137.376h61.989",
    transform: "translate(-3960.58 -543)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_105",
    "data-name": "\\uD328\\uC2A4 105",
    d: "M4426.531,1254.26s32.944-22.687,67.389,0",
    transform: "translate(-3948.252 -604.852)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_9",
    "data-name": "\\uADF8\\uB8F9 9",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 1153.534, 1052.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_106",
    "data-name": "\\uD328\\uC2A4 106",
    d: "M4742.121,1164.067l-67.225,67.225",
    transform: "translate(-3974 -539)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_107",
    "data-name": "\\uD328\\uC2A4 107",
    d: "M4716.107,1164.067l-41.211,41.211",
    transform: "translate(-3936.727 -506.277)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_12",
    "data-name": "\\uADF8\\uB8F9 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_2",
    "data-name": "\\uD0C0\\uC6D0 2",
    transform: "translate(137 452)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 175.5,
    r: 175.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 175.5,
    r: 165.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_6",
    "data-name": "\\uD0C0\\uC6D0 6",
    transform: "translate(176 491)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 136.5,
    r: 136.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 136.5,
    r: 126.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_108",
    "data-name": "\\uD328\\uC2A4 108",
    d: "M4287.545,1105.793s86.444-213.384,107.908-240.879,54.759-51.248,120.6-39.09,89.678,57.213,93.152,81.244,0,263.206,0,263.206",
    transform: "translate(-4130 -539)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_109",
    "data-name": "\\uD328\\uC2A4 109",
    d: "M4442.5,825.9s18.268-71.173,96.416-53.346,55.128,96.642,55.128,96.642",
    transform: "translate(-4130 -539)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_13",
    "data-name": "\\uADF8\\uB8F9 13",
    transform: "translate(533 230.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_2-2",
    "data-name": "\\uD0C0\\uC6D0 2",
    transform: "translate(0 221.315)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 175.5,
    r: 175.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 175.5,
    r: 165.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_6-2",
    "data-name": "\\uD0C0\\uC6D0 6",
    transform: "translate(39 260.315)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 136.5,
    r: 136.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 136.5,
    r: 126.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_108-2",
    "data-name": "\\uD328\\uC2A4 108",
    d: "M4610.752,1105.793s-86.444-213.384-107.908-240.879-54.759-51.248-120.6-39.09-89.678,57.213-93.152,81.244,0,263.206,0,263.206",
    transform: "translate(-4280.297 -769.685)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_109-2",
    "data-name": "\\uD328\\uC2A4 109",
    d: "M4597.209,825.9s-18.268-71.173-96.416-53.346-55.128,96.642-55.128,96.642",
    transform: "translate(-4421.709 -769.685)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app_icon.fc6adf900ea4192440dbabbf2580dea6.svg";
export { ForwardRef as ReactComponent };